/* IND v3 · Rediseño streetwear (oct-2026). Encabezado, paneles, cuenta regresiva y ficha de producto. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ── Encabezado: transparente sobre el hero de la portada, blanco al bajar ── */
  function header() {
    var h = $('[data-i3h]');
    if (!h) return;
    var sec = h.closest('.shopify-section') || h;
    function setH() { document.documentElement.style.setProperty('--i3-hh', sec.offsetHeight + 'px'); }
    setH(); window.addEventListener('resize', setH, { passive: true });
    if (h.hasAttribute('data-over')) {
      var hero = $('[data-ind-vhero]') || $('main .shopify-section');
      var tick = function () {
        var lim = hero ? Math.max(40, hero.getBoundingClientRect().bottom + window.scrollY - sec.offsetHeight - 10) : 40;
        h.classList.toggle('is-top', window.scrollY < lim);
      };
      tick(); window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick, { passive: true });
    }
    /* anuncio rotativo */
    var ms = $$('[data-i3ann] .m');
    if (ms.length > 1) {
      var k = 0;
      setInterval(function () { ms[k].classList.remove('on'); k = (k + 1) % ms.length; ms[k].classList.add('on'); }, 4500);
    }
    /* desplegables de escritorio: uno a la vez, se cierran al hacer clic afuera */
    var dds = $$('.i3dd');
    dds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) dds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    document.addEventListener('click', function (e) { dds.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
  }

  /* ── Paneles (menú, búsqueda, guía de tallas) ── */
  function panels() {
    var last = null;
    function open(id, from) {
      var p = document.getElementById(id); if (!p) return;
      last = from || null;
      p.classList.add('on'); p.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var f = p.querySelector('input[type=search]') || p.querySelector('[data-i3-close]:not(.i3dr__bg):not(.i3s__bg):not(.i3sgd__bg)');
      if (f) setTimeout(function () { f.focus(); }, 60);
    }
    function close(p) {
      p.classList.remove('on'); p.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (last) last.focus();
    }
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-i3-open]');
      if (o) { e.preventDefault(); open(o.getAttribute('data-i3-open'), o); return; }
      var c = e.target.closest('[data-i3-close]');
      if (c) { var p = c.closest('[data-i3-panel]'); if (p) close(p); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('[data-i3-panel].on').forEach(close); });
  }

  /* ── Cuenta regresiva ── */
  function countdowns() {
    $$('[data-i3-cd]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-i3-cd'));
      if (isNaN(end)) { el.hidden = true; return; }
      var f = function (n) { return (n < 10 ? '0' : '') + n; };
      var t = function () {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s === 0) { el.hidden = true; return; }
        $('[data-d]', el).textContent = f(Math.floor(s / 86400));
        $('[data-h]', el).textContent = f(Math.floor(s % 86400 / 3600));
        $('[data-m]', el).textContent = f(Math.floor(s % 3600 / 60));
        $('[data-s]', el).textContent = f(s % 60);
      };
      t(); setInterval(t, 1000);
    });
  }

  /* ── Ficha de producto ── */
  function money(c) { var v = c / 100; return '$' + (c % 100 ? v.toFixed(2) : v); }
  function pdp() {
    var root = $('[data-i3p]'); if (!root) return;
    var dataEl = $('[data-i3-variants]');
    var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var sizeIdx = parseInt(root.getAttribute('data-size-idx'), 10);
    var lowTh = parseInt(root.getAttribute('data-low-th'), 10) || 0;
    var gal = $('[data-gal]', root), dots = $$('[data-cnt] i', root);
    var vid = $('[data-vid]', root), atc = $('[data-atc]', root), atcT = atc && $('.i3-atc-t', atc);
    var price = $('[data-price]', root), cp = $('[data-cp]', root), low = $('[data-low]', root), pick = $('[data-pick]', root);
    var wa = $('[data-wa-link]', root), bar = $('[data-bar]'), barBtn = $('[data-bar-btn]'), barInfo = $('[data-bar-info]');
    var inputs = $$('input[data-oi]', root);
    var nOpts = inputs.reduce(function (m, i) { return Math.max(m, +i.getAttribute('data-oi') + 1); }, 0);

    if (gal && dots.length) gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }, { passive: true });

    function selected() { var s = []; for (var i = 0; i < nOpts; i++) { var c = $('input[data-oi="' + i + '"]:checked', root); s.push(c ? c.value : null); } return s; }
    function find(sel) { return variants.filter(function (v) { return sel.every(function (x, i) { return x === null || v.o[i] === x; }); }); }
    function complete(sel) { return sel.every(function (x) { return x !== null; }); }

    function waHref(v) {
      var t = 'Hola IND, quiero ' + root.getAttribute('data-title');
      if (v) t += ' (' + v.o.join(' / ') + ')';
      t += '. ' + root.getAttribute('data-url') + (v ? '?variant=' + v.id : '');
      return 'https://wa.me/' + root.getAttribute('data-wa') + '?text=' + encodeURIComponent(t);
    }

    function update(fromUser) {
      var sel = selected();
      /* marcar valores sin stock según lo ya elegido en las otras opciones */
      inputs.forEach(function (inp) {
        var i = +inp.getAttribute('data-oi'); var s = sel.slice(); s[i] = inp.value;
        var ok = find(s).some(function (v) { return v.a; });
        inp.parentNode.classList.toggle('na', !ok);
        var lab = $('[data-oval="' + i + '"]', root); if (lab && sel[i]) lab.textContent = sel[i];
      });
      var v = complete(sel) ? find(sel)[0] : null;
      var ref = v || find(sel)[0] || variants[0];
      if (ref) {
        price.textContent = money(ref.p);
        if (cp) { cp.hidden = !(ref.c > ref.p); cp.textContent = money(ref.c); }
      }
      if (v) {
        vid.value = v.id;
        atc.disabled = !v.a;
        atcT.textContent = v.a ? 'Agregar a la bolsa · ' + money(v.p) : 'Agotado';
        if (barBtn) { barBtn.disabled = !v.a; barBtn.textContent = v.a ? 'Agregar' : 'Agotado'; }
        if (barInfo) barInfo.textContent = money(v.p) + ' · ' + v.o.join(' / ');
        if (low) { var show = v.a && v.q !== null && v.q > 0 && v.q <= lowTh; low.hidden = !show; if (show) low.textContent = 'Quedan ' + v.q + (v.q === 1 ? ' unidad' : ' unidades') + ' en esta talla'; }
        if (pick) pick.hidden = true;
        if (fromUser) {
          try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
          if (v.m && gal) { var fig = $('[data-media-id="' + v.m + '"]', gal); if (fig) { if (gal.scrollWidth > gal.clientWidth + 4) gal.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' }); } }
        }
      } else {
        if (low) low.hidden = true;
        if (barInfo && ref) barInfo.textContent = money(ref.p);
      }
      if (wa) wa.href = waHref(v);
      root.__v = v;
    }

    inputs.forEach(function (inp) { inp.addEventListener('change', function () { update(true); }); });
    update(false);

    function needPick() {
      var sel = selected();
      if (complete(sel)) return false;
      if (pick) pick.hidden = false;
      var first = $('.i3p__vals', root);
      if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); first.animate && first.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 }); }
      return true;
    }
    /* antes de que <product-form> envíe: exigir talla elegida */
    if (atc) atc.addEventListener('click', function (e) { if (needPick()) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    var form = atc && atc.form;
    if (form) form.addEventListener('submit', function (e) { if (!complete(selected())) { e.preventDefault(); e.stopImmediatePropagation(); needPick(); } }, true);

    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('on', on); document.body.classList.toggle('i3-bar-on', on);
      }).observe(atc);
      barBtn.addEventListener('click', function () { if (needPick()) return; atc.click(); });
    }
  }

  /* El botón flotante de WhatsApp se aparta (se desvanece) mientras quede encima de un enlace, botón o campo. */
  function waGuard() {
    var CTRL = 'a,button,input,select,textarea,label,summary,[role=button]';
    var pend = false;
    function check() {
      pend = false;
      var w = document.querySelector('.whatsapp-float');
      if (!w || getComputedStyle(w).display === 'none') return;
      var r = w.getBoundingClientRect(), hit = false, pad = 6;
      var pts = [], st = 5;
      for (var gx = 0; gx < st; gx++) for (var gy = 0; gy < st; gy++) pts.push([r.left - pad + (r.width + 2 * pad) * gx / (st - 1), r.top - pad + (r.height + 2 * pad) * gy / (st - 1)]);
      for (var i = 0; i < pts.length && !hit; i++) {
        var els = document.elementsFromPoint(Math.max(0, pts[i][0]), Math.max(0, pts[i][1]));
        for (var k = 0; k < els.length; k++) {
          var e = els[k];
          if (e === w || w.contains(e) || e.id === 'ind-wa-nudge') continue;
          var c = e.closest(CTRL);
          if (c && c !== w && !c.closest('.whatsapp-float')) {
            var cs = getComputedStyle(c);
            if (cs.visibility !== 'hidden' && cs.opacity !== '0') { hit = true; break; }
          }
        }
      }
      w.classList.toggle('i3-wa-off', hit);
    }
    function q() { if (!pend) { pend = true; requestAnimationFrame(check); } }
    addEventListener('scroll', q, { passive: true }); addEventListener('resize', q);
    document.addEventListener('click', function () { setTimeout(q, 350); }, true);
    setTimeout(q, 300); setTimeout(q, 1500);
  }

  function boot() { header(); panels(); countdowns(); pdp(); waGuard(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
